/**
 * Date Utility Helper for formatting timestamps across the casino app.
 */

/**
 * Format a ISO/date string or timestamp into full Indian locale date-time string (e.g. 12/09/2026, 04:30 PM).
 */
export const formatDateTime = (dateValue) => {
  if (!dateValue) return "N/A";
  const date = new Date(dateValue);
  if (isNaN(date.getTime())) return "N/A";

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

/**
 * Format date into date-only string (e.g. 12 Sep 2026).
 */
export const formatDateOnly = (dateValue) => {
  if (!dateValue) return "N/A";
  const date = new Date(dateValue);
  if (isNaN(date.getTime())) return "N/A";

  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

/**
 * Get current year dynamically.
 */
export const getCurrentYear = () => {
  return new Date().getFullYear();
};
